import Presentation from "pages/Presentation";

export default function PresentationPage() {
  return <Presentation />;
}